import "angular";
import DynamicElectionRoutes from "./DynamicElectionRoutes";
import DynamicElectionRoutingController from "./DynamicElectionRoutingController";
import DynamicElectionRoutingService from "./DynamicElectionRoutingService";
import accountService from "../accountServiceModule/AccountService";

var moduleName = "DynamicElectionRoutingModule";

const DynamicElectionRoutingModule = angular
    .module(moduleName, [])
    .controller("DynamicElectionRoutingController", DynamicElectionRoutingController)
    .config(DynamicElectionRoutes)
    .service("DynamicElectionRoutingService", DynamicElectionRoutingService)
    .service("AccountService", accountService);

export default DynamicElectionRoutingModule;
